import { describeResource } from '@siteless/resource';
import { z } from 'zod';
import { doc, getDoc } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';

let oneBallotResourceSchema = z.union([
  z.null(),
  z.record(z.string(), z.string()),
]);

export type OneBallotResourceType = z.infer<typeof oneBallotResourceSchema>;

let OneBallotResource = describeResource('OneBallot', {
  get: async (userId?: string) => {
    if (!userId) return null;

    let ballotData =
      (await getDoc(doc(database, `ballots_${thisOscarsYear}`, userId))).data() ||
      null;

    return oneBallotResourceSchema.parse(ballotData);
  },
});

export default OneBallotResource;
